import styled from '@emotion/styled';
import { Dialog, pxToRem, Tabs, TabsContent } from '@lbcamden/lib-react';

export const ClutterScaleDialog = styled(Dialog)`
  ${({ theme }) => theme.breakpoints.up('md')} {
    min-width: 90vw;
    min-height: ${pxToRem(740)};
    max-height: 90vh;
  }

  ${({ theme }) => theme.breakpoints.up('lg')} {
    min-width: ${pxToRem(920)};
  }
`;

export const ClutterScaleTabs = styled(Tabs)`
  flex: 1;
  overflow: hidden;

  ${TabsContent} {
    overflow: auto;
  }
`;

export const ImageContainer = styled.div`
  flex: 1;
  margin-top: ${({ theme }) => theme.spacing(4)};
`;
